<template>
  <b-container fluid v-if="!loading">
    <b-row>
      <b-col xl="6" lg="6" md="12" cols="12">
        <div class="img-center pt-5 ps-3">
          <div class="logo">
            <img src="../../../../assets/logo/CrmLogo.png" style="border-radius: 50%" />

            <!-- <img src="../../../../assets/logo/MoceroLogo.png" style="border-radius: 50%" /> -->

            <!-- <img src="../../../../assets/logo/MedwayFaviconLogo.png" style="border-radius: 50%" /> -->

            <!-- <img
              src="../../../../assets/logo/AttuneLogo.png"
              style="border-radius: 50%"
            /> -->
          </div>
          <div>
            <p class="logo-txt mb-0">CRM</p>
            <p class="logo-txt-green">A product of Mocero Health</p>
          </div>
        </div>
        <div class="p-3 login-card">
          <b-form @submit.prevent="login()">
            <div class="field">
              <TextField type="text" v-model="login_data.doctor_user_name" :rules="{ required: true }"
                :required-icon="true" name="Email" id="Email" label="Email address" />
            </div>

            <div class="field mb-0 position-relative">
              <div class="blue-txt pwd-icon" @click="showhide()">
                <i v-if="show == true" class="pi pi-eye-slash"></i>
                <i v-else class="pi pi-eye"></i>
              </div>
              <TextField :txttype="showtxt" v-model="login_data.doctor_user_password" :rules="{ required: true }"
                :required-icon="true" name="Password" id="Password" label="Password" toggleMask autocomplete="off" />
            </div>
            <p class="float-end blue-txt mt-1" @click="$router.push('/forgotpassword')">
              Forgot Password
            </p>
            <!-- <b-button type="submit" variant="primary" style="width: 100%" class="signinbtn">Sign in</b-button> -->
            <b-button type="submit" style="width: 100%" class="signinbtn mt-4" :disabled="loginBtnLoader">
              <span v-if="loginBtnLoader">Signing in...</span>
              <span v-else>Sign in</span>
            </b-button>
            <p :class="loginmsgdata.class" class="pt-3" v-if="loginmsgdata.loginmsg">
              {{ loginmsgdata.loginmsg }}
            </p>
            <p class="mt-1">
              Need any help? <span class="blue-txt">Click Here</span>
            </p>
          </b-form>
        </div>
      </b-col>
      <b-col xl="6" lg="6" sm="6" cols="12" class="slider d-none d-lg-block">
        <div class="slider-bg">
          <div class="slider-asset-bg">
            <Carousel :value="inventoryscroll" :numVisible="1" :numScroll="1" :autoplayInterval="3000">
              <template #item="slotProps">
                <div class="slidersss">
                  <div class="slider-heading">
                    <h3>{{ slotProps.data.heading }}</h3>
                    <p class="pt-2">{{ slotProps.data.content }}</p>
                  </div>
                  <div class="slider-img">
                    <img :src="slotProps.data.img" :class="slotProps.data.class" />
                  </div>
                </div>
              </template>
            </Carousel>
          </div>
        </div>
      </b-col>
    </b-row>
    <Dialog v-model:visible="RoleSPopup" modal header="Choose Role" :style="{ width: '50vw' }" class="overall-bg"
      :breakpoints="{
        '1980px': '55vw',
        '1440px': '60vw',
        '960px': '70vw',
        '640px': '90vw',
      }">
      <b-container fluid>
        <b-row>
          <b-col lg="4" md="4" v-for="items in RolesData">
            <div class="details-card d-flex justify-content-center overall-grey MouseHover" @click="
              RoleCardClick(
                items['UserId'],
                items['RoleId'],
                items['RoleName']
              )
              ">
              <p>{{ items["RoleName"] }}</p>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </Dialog>
  </b-container>
  <img src="../../../../assets/Img/CRMLoginLoader.png" v-if="loading"
    :class="['loader-loading', { 'animate-up': loading }]" />
</template>

<script lang="ts">
import { defineComponent, ref, watchEffect } from "vue";
import service from "../../service/LoginService";
import { useRoute, useRouter } from "vue-router";
//import { useInventoryStore } from "../../stores/Index";
import Helper from "../../../../helper/helpers";
import Loader from "../../../../components/FormComponents/Loader.vue";
import { useForm } from "vee-validate";
import { useI18n } from 'vue-i18n';
import TextField from "../../../../components/FormComponents/TextInput.vue";
import { show } from "dom7";
import EntityMasterservice from "../../service/EntityMasterService";
import Footer from "../../../../components/FormComponents/Footer.vue";
import TeleCallService from "../../service/teleCallService";
import CommonService from "../../service/commonService";

export default defineComponent({
  props: {
    trigger: {
      readonly: false,
      type: Boolean,
      default: ref(false),
    },
  },
  components: {
    Loader,
    TextField,
    Footer,
  },
  setup(_, { emit }) {
    debugger;
    let loginBtnLoader = ref(false);

    const inventoryscroll = ref([
      {
        heading: "Dashboard",
        content:
          "The Dashboard is a pivotal component tailored to meet your every need. It serves as a dynamic and user-friendly interface that offers a comprehensive summary of critical metrics related to calls, leads, and site visits. •	Users can access the Dashboard to gain instant insights into the status and performance of their operations. This feature provides a consolidated view of essential data, enabling users to assess the effectiveness of their strategies and take proactive measures to achieve their goals.",
        img: "/src/assets/Img/crmslider1.png",
      },
      {
        heading: "My Tasks",
        content:
          "My Tasks is a task management component designed for both administrative personnel and team members in the pre-sales and post-sales teams. •	Users can create, assign, track, and update tasks within this section, ensuring efficient task management and clear visibility into individual and team responsibilities.",
        img: "/src/assets/Img/crmslider2.png",
      },
      {
        heading: "Masters",
        content:
          "Masters section is a central hub for configuring and managing various aspects related to contacts and leads. Status - This sub-feature allows you to define and oversee the status of leads or contacts.Source - Source enables the setup and management of the sources from which leads or contacts originate.Agent - Agent functionality allows you to set up and manage the client-handling agents responsible for interactions with leads or contacts.",
        img: "/src/assets/Img/crmslider3.png",
      },
      {
        heading: "Reports",
        content:
          "Reports are likely a separate feature that provides insights and analytics based on the data stored within the CRM. This section allows users to generate various reports, providing valuable information and data-driven insights that can inform decision-making and strategy.",
        img: "/src/assets/Img/crmslider4.png",
      },
    ]);
    const route = useRouter();
    const loginmsgdata = ref({
      loginmsg: "",
      //  showMessage: false,
      class: "",
    });
    const loginmsg = ref("");
    const showMessage = ref(false);
    const login_data = ref({
      doctor_user_name: "",
      doctor_user_password: "",
      fcm_token: "",
      application_type: "",
    });

    let RoleSPopup = ref(false);
    let RolesData = ref([]);
    //Loader...
    let loading = ref(false);
    let show = ref(true);
    let showtxt = ref("Password");
    function showhide() {
      if (show.value == true) {
        show.value = false;
        showtxt.value = "text";
      } else {
        show.value = true;
        showtxt.value = "Password";
      }
    }
    watchEffect(() => {
      if (loading.value) {
        //login();
      }
    });
    const { handleSubmit, errors } = useForm();

    //login
    const login = handleSubmit(async (values) => {
      debugger;
      loginBtnLoader.value = true;
      let objlogin = Object.assign(login_data.value);
      console.log(objlogin);
      try {
        const data_response = await service.GetRoles(
          login_data.value.doctor_user_name,
          login_data.value.doctor_user_password
        );
        console.log(data_response);

        if (data_response["result"][0].RoleId == 1) {
          const UserResponse = await service.Login(
            data_response["result"][0].UserId
          );

          console.log("LocalStorageData", UserResponse["result"]);

          let OrganizationId = UserResponse["result"][0].OrganizationId;
          let OrganizationCode = UserResponse["result"][0].OrganizationCode;
          let BranchId = UserResponse["result"][0].BranchId;
          let BranchCode = UserResponse["result"][0].BranchCode;
          let UserName = UserResponse["result"][0].UserName;
          let UserStatus = UserResponse["result"][0].IsActive;
          let phoneNumber = UserResponse["result"][0].MobileNumber;
          let HospitalId = UserResponse["result"][0].HospitalId;
          let HospitalCode = UserResponse["result"][0].HospitalCode;
          let HospitalBranchId = UserResponse["result"][0].HospitalBranchId;
          let HospitalBranchCode = UserResponse["result"][0].HospitalBranchCode;
          let ApplicationType = UserResponse["result"][0].ApplicationType;
          let CountryId = UserResponse["result"][0].CountryId;
          let AgentNumber = UserResponse["result"][0].AgentNumber;
          let IsEntitySMS = UserResponse["result"][0].IsEntitySMS;

          let UsersData = {
            OrganizationId: OrganizationId,
            OrganizationCode: OrganizationCode,
            BranchId: BranchId,
            BranchCode: BranchCode,
            UserId: data_response["result"][0].UserId,
            UserName: UserName,
            UserStatus: UserStatus,
            phoneNumber: phoneNumber,
            HospitalId: HospitalId,
            HospitalCode: HospitalCode,
            HospitalBranchId: HospitalBranchId,
            HospitalBranchCode: HospitalBranchCode,
            ApplicationType: ApplicationType,
            CountryId: CountryId,
            AgentNumber: AgentNumber,
            IsEntitySMS: IsEntitySMS
          };

          localStorage.setItem("UsersData", JSON.stringify(UsersData));

          Helper.setAuth(UsersData);
          debugger;
          const response = await service.Session(UsersData);
          console.log(response);

          let RolesData = {
            RoleId: data_response["result"][0].RoleId,
            RoleName: data_response["result"][0].RoleName,
          };

          localStorage.setItem("RolesData", JSON.stringify(RolesData));

          route.push({
            path: "/UserMaster",
          });

          return;
        }

        if (data_response["result"][0] == "Invalid") {
          loginmsgdata.value.class = "red";
          loginmsgdata.value.loginmsg = "Invalid Username or Password";
          loginBtnLoader.value = false;
          setTimeout(() => {
            loginmsgdata.value.loginmsg = "";
          }, 5000);
          return;
        } else {
          if (data_response["result"].length > 1) {
            loginBtnLoader.value = false;
            RoleSPopup.value = true;
            RolesData.value = data_response["result"];
          } else if (data_response["result"].length == 1) {
            RoleSPopup.value = false;
            RoleCardClick(
              data_response["result"][0].UserId,
              data_response["result"][0].RoleId,
              data_response["result"][0].RoleName
            );
          } else {
            loginBtnLoader.value = false;
            alert("Somthing went wrong");
            return;
          }
        }
      } catch (error) {
        loginBtnLoader.value = false;
        console.log(error);
        alert(error);
      }
    });

    async function RoleCardClick(UserId, RoleId, RoleName) {
      debugger;
      RoleSPopup.value = false;
      loading.value = true;

      const UserResponse = await service.Login(UserId);

      console.log(UserResponse["result"]);

      let OrganizationId = UserResponse["result"][0].OrganizationId;
      let OrganizationCode = UserResponse["result"][0].OrganizationCode;
      let BranchId = UserResponse["result"][0].BranchId;
      let BranchCode = UserResponse["result"][0].BranchCode;
      let UserName = UserResponse["result"][0].UserName;
      let UserStatus = UserResponse["result"][0].IsActive;
      let phoneNumber = UserResponse["result"][0].MobileNumber;
      let AgentId =
        UserResponse["result"][0].AgentId == null
          ? 0
          : UserResponse["result"][0].AgentId;

      let AgentStatus = UserResponse["result"][0].AgentStatus;

      let AgentDid =
        UserResponse["result"][0].AllowedDidNumbers == null
          ? 0
          : UserResponse["result"][0].AllowedDidNumbers;
      let Admin =
        UserResponse["result"][0].IsAdmin == null
          ? 0
          : UserResponse["result"][0].IsAdmin;
      let HospitalId = UserResponse["result"][0].HospitalId;
      let HospitalCode = UserResponse["result"][0].HospitalCode;
      let HospitalBranchId = UserResponse["result"][0].HospitalBranchId;
      let HospitalBranchCode = UserResponse["result"][0].HospitalBranchCode;
      let ApplicationType = UserResponse["result"][0].ApplicationType;
      let CountryId = UserResponse["result"][0].CountryId;
      let AgentNumber = UserResponse["result"][0].AgentNumber;
      let ProductId = UserResponse["result"][0].ProductId;
      let IsEntitySMS = UserResponse["result"][0].IsEntitySMS;

      let UsersData = {
        OrganizationId: OrganizationId,
        OrganizationCode: OrganizationCode,
        BranchId: BranchId,
        BranchCode: BranchCode,
        UserId: UserId,
        UserName: UserName,
        UserStatus: UserStatus,
        phoneNumber: phoneNumber,
        AgentId: AgentId,
        AgentStatus: AgentStatus,
        AgentDid: AgentDid,
        Admin: Admin,
        HospitalId: HospitalId,
        HospitalCode: HospitalCode,
        HospitalBranchId: HospitalBranchId,
        HospitalBranchCode: HospitalBranchCode,
        ApplicationType: ApplicationType,
        CountryId: CountryId,
        AgentNumber: AgentNumber,
        ProductId: ProductId,
        IsEntitySMS: IsEntitySMS
      };

      localStorage.setItem("UsersData", JSON.stringify(UsersData));

      Helper.setAuth(UsersData);
      debugger;
      const response = await service.Session(UsersData);
      console.log(response);

      let RolesData = {
        RoleId: RoleId,
        RoleName: RoleName,
      };

      localStorage.setItem("RolesData", JSON.stringify(RolesData));

      if (
        UserResponse["result"][0].ApplicationType == 2 &&
        UserResponse["result"][0].AgentId != null
      ) {
        const ObjValue = ref({
          AgentID: UserResponse["result"][0].AgentId,
          status: 1,
        });

        const DataResponse = await TeleCallService.AgentBlockAndUnblock(
          ObjValue.value
        );
      }

      //get entity (Form Name)
      // let EntityResponse = await EntityMasterservice.GetEntityByModuleId(5,OrganizationId);
      // console.log(EntityResponse);
      // let ModuleId = 5;
      //Get role rights

      // let GetRightsResponse = await EntityMasterservice.GetRightsByRoleId(
      //   RoleId,
      //   ModuleId,
      //   OrganizationId
      // );
      // console.log(GetRightsResponse);

      loginmsgdata.value.loginmsg = "Login Successfully";
      loginmsgdata.value.class = "green";
      setTimeout(() => {
        loginmsgdata.value.loginmsg = "";
      }, 5000);

      loading.value = false;

      route.push({
        path: "/crmdashboard",
      });

      LoadCachData();
    }

    async function LoadCachData() {
      debugger;

      //get local storage session data
      let SessionUserData = localStorage.getItem("UsersData");
      let usersData: any;
      if (SessionUserData !== null) {
        usersData = JSON.parse(SessionUserData);
      }

      const response = await CommonService.LoadHMSTaskType(
        usersData.OrganizationId
      );
      const response1 = await CommonService.LoadOrganizationList();
      const response2 = await CommonService.LoadBranchList();
      const response3 = await CommonService.LoadDepartmentList();
      const response4 = await CommonService.LoadSubDepartmentList();
      const response5 = await CommonService.LoadOrganizationConfigList();
    }

    return {
      showtxt,
      show,
      showhide,
      inventoryscroll,
      route,
      login_data,
      login,
      loading,
      loginmsg,
      loginmsgdata,
      RoleSPopup,
      RolesData,
      RoleCardClick,
      loginBtnLoader
    };
  },

  methods: {},
});
</script>

<style scoped>
.red {
  font-size: 14px !important;
  color: red;
}

.green {
  font-size: 14px !important;
  color: green;
}

.logo {
  background-color: #f7f7f8;
  border-radius: 50%;
  margin-right: 10px;
}

.logo img {
  width: 40px;
  margin: 5px;
}

.img-center {
  display: flex;
  align-items: center;
}

.logo-txt {
  font-weight: 500;
  font-size: 18px;
  color: #444444;
}

.logo-txt-green {
  font-size: 12px;
  color: #55c0a2;
}

.login-card form {
  width: 75%;
  margin-bottom: 10%;
}

.login-card .p-button {
  justify-content: center;
  font-size: 12px;
}

.login-card p {
  font-size: 12px;
}

.slider-col {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.slider-bg {
  border-radius: 25px;
  margin: 15px;
  background-image: linear-gradient(#4153ef, #501bad);
  height: 95vh;
}

.slider-asset-bg {
  background-image: url(../../../../assets/Img/slider-bg.png);
  background-size: cover;
  background-position-y: center;
  height: 100%;
  width: 100%;
  padding: 30px;
}

.slider-img {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 0px 15px 0px;
  min-height: 73vh;
}

.slider-img img {
  width: 75%;
}

.slider-heading {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.slider-heading h3 {
  color: #ffffff !important;
  font-size: 24px;
  font-weight: 400 !important;
}

.slider-heading p {
  color: #ffffff !important;
  font-size: 12px;
  text-align: center;
  line-height: 18px;
}

.login-card {
  height: 80vh;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.pwd-icon {
  position: absolute;
  right: 15px;
  top: 35px;
}

.loader-loading {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  transition: transform 3s ease-out;
}

.animate-up {
  animation: slide-up 5s infinite;
}

.signinbtn {
  background-color: #4153ef;
  margin-top: 35px;
}

@keyframes slide-up {
  0% {
    transform: translate(-50%, 100%);
  }

  50% {
    transform: translate(-50%, -100%);
  }

  100% {
    transform: translate(-50%, 0);
  }
}

@media screen and (min-width: 1440px) {
  .login-card form {
    width: 50%;
  }
}

.MouseHover:hover {
  background-color: #f4f4f4;
  /* Change the background color on hover */
  cursor: pointer;
  /* Change the cursor to a pointer on hover (optional) */
}
</style>
<style lang="scss">
.p-button.signinbtn:focus {
  background-color: #4153ef !important;
  margin-top: 35px;
}

.slider-asset-bg .p-carousel .p-carousel-indicators .p-carousel-indicator.p-highlight button {
  box-shadow: none !important;
  border-radius: 25px !important;
}
</style>
